import React, { FC, Ref } from "react";
import { TextInput, CurrencyInput, PasswordInput } from "../../atoms/TextInput";
import { InputField, InputTitle } from "./elements";

type Props = {
  label: string;
  placeholder?: string;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  onFocus?: (e: any) => void;
  maxLength?: number;
  type: "default" | "currency" | "password";
  value?: string | number;
  name?: string;
  disabled?: boolean;
  visibilityToggle?: boolean;
  noMarginTop?: boolean;
  error?: boolean;
  inputRef?: Ref<any>;
};

const InputWithLabel: FC<Props> = (props) => {
  const {
    label,
    placeholder,
    onChange,
    onBlur,
    onFocus,
    type,
    value,
    name,
    disabled,
    visibilityToggle,
    error,
    noMarginTop,
    maxLength,
    inputRef,
  } = props;

  return (
    <InputField noMarginTop={noMarginTop || false}>
      <InputTitle>{label}</InputTitle>
      {type === "default" ? (
        <TextInput
          placeholder={placeholder || ""}
          onChange={onChange}
          onBlur={onBlur}
          onFocus={onFocus}
          maxLength={maxLength}
          //@ts-ignore
          value={value}
          name={name}
          disabled={disabled}
          $error={error}
          inputRef={inputRef}
        />
      ) : null}
      {type === "currency" ? (
        <CurrencyInput
          name={name}
          onChange={onChange || undefined}
          //@ts-ignore
          value={value}
          disabled={disabled}
        />
      ) : null}
      {type === "password" ? (
        <PasswordInput
          placeholder={placeholder || ""}
          onChange={onChange || undefined}
          //@ts-ignore
          value={value}
          name={name}
          disabled={disabled}
          visibilityToggle={visibilityToggle}
          $error={error}
        />
      ) : null}
    </InputField>
  );
};

export default InputWithLabel;
